import {type FC, useEffect, useRef, useState} from 'react';
import WeatherApi from '../../../apis/callWeatherApi.ts';
import {Col, Container, DateTimeText, Row} from './Weather.styled.ts';
import {setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';

const Weather: FC = () => {
    const {ref, focused} = useFocusable({
        focusKey: 'weather',
        onArrowPress: (direction) => {
            if (direction === 'up') {
                setFocus('center-info');
                return false;
            }
            if (direction === 'down') {
                setFocus('iptv');
                return false;
            }
            return direction !== 'left';
        },
        onEnterPress: () => {
            handleClick();
        }
    });

    const [temp, setTemp] = useState<string>('');
    const [icon, setIcon] = useState<string>('04d');
    const fetchData = async () => {
        try {
            const res = await WeatherApi.getCurrentWeather(import.meta.env.VITE_LOC_LAT, import.meta.env.VITE_LOC_LON);
            setTemp(Math.round(res.main.temp * 10) / 10 + '');
            const iconModule = await import(`../../../assets/images/${res.weather[0].icon}.png`);
            setIcon(iconModule.default);
        } catch (e: any) {
            const iconModule = await import(`../../../assets/images/04d.png`);
            setIcon(iconModule.default);
            setTemp('20.1');
            console.error('키를 다시 확인해 주세요.', e);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [currentTime, setCurrentTime] = useState(new Date());
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        const updateWeather = setInterval(() => {
            fetchData();
        }, 3600000);

        return () => {
            clearInterval(timer);
            clearInterval(updateWeather);
        };
    }, []);

    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const year = currentTime.getFullYear();
    const month = (currentTime.getMonth() + 1).toString().padStart(2, '0');
    const day = currentTime.getDate().toString().padStart(2, '0');
    const weekday = weekdays[currentTime.getDay()];
    const hours = currentTime.getHours().toString().padStart(2, '0');
    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
    const seconds = currentTime.getSeconds().toString().padStart(2, '0');

    const clickCountRef = useRef(0);
    const handleClick = async () => {
        clickCountRef.current += 1;
        if (clickCountRef.current === 3) {
            clickCountRef.current = 0;
            try {
                const result = await window.rustdesk.launch();
                if (result.success) {
                    console.log('성공적으로 요청했습니다.');
                } else {
                    alert('원격 지원에 문제가 생겼습니다. 고객센터: 1551-8381');
                }
            } catch (err) {
                alert('정상 동작이 아닙니다.');
            }
        }
    };

    return (
        <Container ref={ref} $focused={focused}>
            <Row>
                <Col size={7} style={{display: 'grid', textAlign: 'right'}}>
                    <DateTimeText>{year} 년</DateTimeText>
                    <DateTimeText>
                        {month}월 {day}일
                    </DateTimeText>
                    <DateTimeText>({weekday}요일)</DateTimeText>
                </Col>
                <Col size={5} style={{textAlign: 'center', fontSize: '1.5rem'}}>
                    {hours}:{minutes}:{seconds}
                </Col>
            </Row>
            <Row>
                <Col size={7} style={{textAlign: 'center', fontSize: '1.7rem'}}>
                    {temp}°<sup>c</sup>
                </Col>
                <Col size={5} style={{textAlign: 'center'}}>
                    <img src={icon} alt="weather_icon" />
                </Col>
            </Row>
        </Container>
    );
};
export default Weather;
